import parsePhoneNumberFromString from 'libphonenumber-js';
import * as Yup from 'yup';
import i18n from 'Utilities/i18n';
const createYupSchema = (step, app) => {
  const schemaStep = step === 0 ? 'confirmCountry' : step === 1 ? 'initialAccount' : step === 2 || step === 3 ? 'adultAccount' : step === 4 ? 'minorInfo' : 'minorAccount';
  const confirmCountry = {
    country: Yup.string().required()
  };
  const initialAccount = {
    firstName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.firstName.errors.required')).trim(),
    lastName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.lastName.errors.required')).trim(),
    dateOfBirth: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.dob.errors.required')),
    gender: Yup.string().when('country', {
      is: country => country === 'FR' && app !== 'llu',
      // FR fields are not required for LLU atm
      then: Yup.string().required(),
      otherwise: Yup.string().notRequired()
    }),
    birthCountry: Yup.string().when('country', {
      is: country => country === 'FR' && app !== 'llu',
      then: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplace.errors.required')),
      otherwise: Yup.string().notRequired()
    }),
    birthZipCode: Yup.string().when(['country', 'birthCountry'], {
      is: (country, birthCountry) => country === 'FR' && birthCountry === 'FR',
      then: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoForm.formField.birthplaceZipCode.errors.required')),
      otherwise: Yup.string().notRequired()
    })
  };
  const adultAccount = {
    email: Yup.string().email(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.errors.emailAddressValidEmail')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.email.errors.required')),
    mobileNumber: Yup.string().when('country', {
      is: country => country === 'US' && app !== 'llu',
      then: Yup.string().required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).min(7, i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber')).test('test-valid-phone', i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.phoneNumber.errors.validPhoneNumber'), value => {
        var _parsePhoneNumberFrom;
        return ((_parsePhoneNumberFrom = parsePhoneNumberFromString(value ?? '', {
          extract: false
        })) === null || _parsePhoneNumberFrom === void 0 ? void 0 : _parsePhoneNumberFrom.isValid()) ?? false;
      }),
      otherwise: Yup.string().notRequired()
    }),
    confirmPassword: Yup.string().oneOf([Yup.ref('password')], i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.confirmPasswordMustMatch')).required(i18n.t('CreateAccountAccountInfo.content.createAccountAccountInfoForm.formField.confirmPassword.errors.required'))
  };
  const minorAccount = {
    guardianFirstName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentFirstName.helpText.required')).trim(),
    guardianLastName: Yup.string().required(i18n.t('CreateAccountPersonalInfo.content.createAccountPersonalInfoFormMinor.formField.parentLastName.helpText.required')).trim()
  };
  let schema = confirmCountry;
  switch (schemaStep) {
    case 'initialAccount':
      schema = {
        ...confirmCountry,
        ...initialAccount
      };
      break;
    case 'adultAccount':
      schema = {
        ...confirmCountry,
        ...initialAccount,
        ...adultAccount
      };
      break;
    case 'minorInfo':
      schema = {
        ...confirmCountry,
        ...initialAccount,
        ...minorAccount
      };
      break;
    case 'minorAccount':
      schema = {
        ...confirmCountry,
        ...initialAccount,
        ...adultAccount,
        ...minorAccount
      };
      break;
    default:
      break;
  }
  return Yup.object().shape(schema);
};
export { createYupSchema };